module.exports = __webpack_public_path__ + "img/Frame117.a9d4ba68.png";